module.exports = __webpack_public_path__ + "static/media/rewards.b4f7c9cb.png";